"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBoolean = void 0;
const zod_1 = require("zod");
/**
 * Tham số trên URL luôn là chuỗi, mà `z.coerce.boolean()` coi mọi chuỗi khác rỗng
 * là true — nên "false" cũng thành true và các ô lọc dạng bật/tắt mất tác dụng.
 */
exports.QueryBoolean = zod_1.z
    .union([zod_1.z.boolean(), zod_1.z.enum(["true", "false", "1", "0", ""])])
    .transform((v) => (typeof v === "boolean" ? v : v === "true" || v === "1"));
